/* Milano buy box */
(function () {
  function init(root) {
    if (!root || root.dataset.mlbReady === '1') return;
    var dataEl = root.querySelector('[data-mlb-data]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = DATA.variants || [];
    var S = DATA.strings || {};

    var idInput = root.querySelector('[data-mlb-id]');
    var atcBtn = root.querySelector('[data-mlb-atc]');
    var atcText = root.querySelector('[data-mlb-atc-text]');
    var atcPrice = root.querySelector('[data-mlb-atc-price]');
    var priceNow = root.querySelector('[data-mlb-price]');
    var priceWas = root.querySelector('[data-mlb-compare]');
    var priceSave = root.querySelector('[data-mlb-save]');
    var stockWrap = root.querySelector('.mlb-ships');
    var stockText = root.querySelector('[data-mlb-stock-text]');
    var slides = [].slice.call(root.querySelectorAll('[data-mlb-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-mlb-thumb]'));

    /* Productos sin opciones (una sola version, "Default Title") no pintan
       selector, asi que no hay ningun radio que leer. Sin esta bandera la
       busqueda de variante no encuentra nada y el boton se queda en
       "Agotado" aunque haya stock. */
    var hayOpciones = root.querySelectorAll('[data-mlb-option]').length > 0;

    /* ---------------------------------------------------------------
       Agrupar las fotos por opcion, leyendo su texto alternativo.

       Cada foto puede quedar etiquetada con UN valor por cada opcion
       del producto. Ejemplos con Color + Cierre:

         "Bolso Milano en negro, de estudio"        -> {Color: Negro}
         "Interior ... con cierre de cremallera"    -> {Cierre: Cremallera}
         "Bolso Milano en negro con cremallera"     -> {Color: Negro, Cierre: Cremallera}
         "Detalle de la piel resistente al agua"    -> sin etiqueta, sale siempre

       Una foto se ve si TODAS las etiquetas que lleva coinciden con lo
       que hay elegido. Las que no llevan ninguna son comunes y salen
       con cualquier combinacion.

       Asi no hay que tocar el Liquid: basta con escribir bien los alt.
    --------------------------------------------------------------- */
    var valoresPorPosicion = {};
    variants.forEach(function (v) {
      (v.options || []).forEach(function (val, i) {
        var p = i + 1;
        if (!valoresPorPosicion[p]) valoresPorPosicion[p] = [];
        if (valoresPorPosicion[p].indexOf(val) < 0) valoresPorPosicion[p].push(val);
      });
    });

    var grupoDeMedia = {};   // mediaId -> { '1': 'Negro', '2': 'Cremallera' }
    var hayGrupos = false;

    if (hayOpciones) {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        var alt = (img && img.alt ? img.alt : '').toLowerCase();
        if (!alt) return;

        var etiquetas = {};
        Object.keys(valoresPorPosicion).forEach(function (p) {
          var mejor = '';
          valoresPorPosicion[p].forEach(function (val) {
            if (!val) return;
            // el valor mas largo gana, por si un nombre contiene a otro
            if (alt.indexOf(val.toLowerCase()) >= 0 && val.length > mejor.length) mejor = val;
          });
          if (mejor) etiquetas[p] = mejor;
        });

        if (Object.keys(etiquetas).length) {
          grupoDeMedia[s.dataset.mediaId] = etiquetas;
          hayGrupos = true;
        }
      });
    }

    /* ---------------------------------------------------------------
       Orden de la galeria. Tres grupos:
         0 - fotos del color elegido        -> primero
         1 - fotos comunes, sin etiqueta    -> en medio
         2 - fotos de otra opcion (cierre)  -> al final
       Se recolocan moviendo al final primero las del grupo 1 y luego
       las del 2, asi la del cierre queda siempre la ultima.
    --------------------------------------------------------------- */
    function rangoDeMedia(mediaId) {
      var g = grupoDeMedia[mediaId];
      if (!g) return 1;
      if (g['1']) return 0;
      return 2;
    }

    if (hayGrupos) {
      var escena = slides.length ? slides[0].parentNode : null;
      var tira = thumbs.length ? thumbs[0].parentNode : null;
      [1, 2].forEach(function (rango) {
        slides.forEach(function (s) {
          if (escena && rangoDeMedia(s.dataset.mediaId) === rango) escena.appendChild(s);
        });
        thumbs.forEach(function (t) {
          if (tira && rangoDeMedia(t.dataset.mediaId) === rango) tira.appendChild(t);
        });
      });
      slides = [].slice.call(root.querySelectorAll('[data-mlb-slide]'));
      thumbs = [].slice.call(root.querySelectorAll('[data-mlb-thumb]'));
    }

    function esVisible(mediaId, opts) {
      var g = grupoDeMedia[mediaId];
      if (!g) return true;
      for (var p in g) {
        if (g[p] !== opts[parseInt(p, 10) - 1]) return false;
      }
      return true;
    }

    /* Ya no se ocultan las fotos de otros colores: las del color elegido
       (y las comunes) van primero y las demas detras, como secundarias. */
    function filtrarPorOpciones(opts) {
      var escena = slides.length ? slides[0].parentNode : null;
      var tira = thumbs.length ? thumbs[0].parentNode : null;
      var primero = null;
      [true, false].forEach(function (delColor) {
        slides.forEach(function (s) {
          s.hidden = false;
          if (esVisible(s.dataset.mediaId, opts) === delColor) {
            if (escena) escena.appendChild(s);
            if (delColor && !primero) primero = s;
          }
        });
        thumbs.forEach(function (t) {
          t.hidden = false;
          if (esVisible(t.dataset.mediaId, opts) === delColor && tira) tira.appendChild(t);
        });
      });
      slides = [].slice.call(root.querySelectorAll('[data-mlb-slide]'));
      thumbs = [].slice.call(root.querySelectorAll('[data-mlb-thumb]'));
      return primero || slides[0] || null;
    }

    function activar(slide) {
      if (!slide) return;
      slides.forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        if (!on) {
          var vid = s.querySelector('video');
          if (vid && !vid.paused) vid.pause();
        }
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(slide.dataset.mediaId));
      });
      var img = slide.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }

    function slidePorMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) return slides[i];
      }
      return null;
    }

    function thumbPorMedia(mediaId) {
      for (var i = 0; i < thumbs.length; i++) {
        if (String(thumbs[i].dataset.mediaId) === String(mediaId)) return thumbs[i];
      }
      return null;
    }

    /* La foto principal de la variante elegida se pone la primera de la tira. */
    function alFrente(mediaId) {
      var s = slidePorMedia(mediaId);
      if (s && s.parentNode && s.parentNode.firstChild !== s) {
        s.parentNode.insertBefore(s, s.parentNode.firstChild);
      }
      var t = thumbPorMedia(mediaId);
      if (t && t.parentNode && t.parentNode.firstChild !== t) {
        t.parentNode.insertBefore(t, t.parentNode.firstChild);
        if (t.parentNode.scrollLeft) t.parentNode.scrollLeft = 0;
      }
    }

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-mlb-option]').forEach(function (input) {
        if (input.checked) out[parseInt(input.dataset.mlbOption, 10) - 1] = input.value;
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var ok = true;
        for (var j = 0; j < vo.length; j++) { if (vo[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }

    function paintSelection() {
      root.querySelectorAll('.mlb-swatch').forEach(function (label) {
        var input = label.querySelector('input');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
      root.querySelectorAll('[data-mlb-optlabel]').forEach(function (span) {
        var checked = root.querySelector('[data-mlb-option="' + span.dataset.mlbOptlabel + '"]:checked');
        if (checked) span.textContent = checked.value;
      });
    }

    function update() {
      paintSelection();
      var opts = selectedOptions();
      var v = hayOpciones ? findVariant(opts) : (variants[0] || null);

      if (!v) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = S.soldOut || 'Agotado';
        if (atcPrice) atcPrice.textContent = '';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) { priceWas.textContent = v.compare || ''; priceWas.hidden = !v.onSale; }
      if (priceSave) {
        priceSave.textContent = (S.save || 'Ahorra') + ' −' + v.pct + '%';
        priceSave.hidden = !v.onSale;
      }
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? (S.atc || 'Añadir al carrito') : (S.soldOut || 'Agotado');
      if (atcPrice) atcPrice.textContent = v.available ? '· ' + v.price : '';
      if (stockText) stockText.textContent = v.available ? (S.stockIn || 'En stock') : (S.stockOut || 'Sin stock');
      if (stockWrap) stockWrap.classList.toggle('is-out', !v.available);

      if (hayGrupos) {
        var primero = filtrarPorOpciones(opts);
        if (v.mediaId) alFrente(v.mediaId);
        var delVariante = slidePorMedia(v.mediaId);
        if (delVariante && delVariante.hidden) delVariante = null;
        activar(delVariante || primero);
      } else {
        activar(slidePorMedia(v.mediaId));
      }

      if (hayOpciones) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-mlb-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activar(slidePorMedia(thumb.dataset.mediaId));
      });
    });

    root.querySelectorAll('[data-mlb-pop]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = root.querySelector('[data-mlb-popbox="' + btn.dataset.mlbPop + '"]');
        if (box) box.hidden = false;
      });
    });
    root.querySelectorAll('[data-mlb-popclose]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-mlb-popbox]');
        if (box) box.hidden = true;
      });
    });

    /* ---------------------------------------------------------------
       Carrito: engancharse al del tema.
       Sin esto el formulario hace un POST normal y manda a la clienta
       a la pagina /cart, saliendose de la ficha.
    --------------------------------------------------------------- */
    var formulario = root.querySelector('[data-mlb-form]');
    var enganchado = false;
    function engancharCarrito() {
      if (enganchado || !formulario) return true;
      if (!window.theme || typeof theme.AjaxProduct !== 'function') return false;
      try {
        new theme.AjaxProduct(formulario, '.mlb-atc');
        enganchado = true;
        formulario.dataset.mlbAjax = '1';
      } catch (e) { return false; }
      return true;
    }
    if (!engancharCarrito()) {
      window.addEventListener('load', engancharCarrito);
      var intentos = 0;
      var reloj = setInterval(function () {
        intentos++;
        if (engancharCarrito() || intentos > 20) clearInterval(reloj);
      }, 250);
    }

    root.dataset.mlbReady = '1';
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mlb]').forEach(init);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mlb-popbox]').forEach(function (box) { box.hidden = true; });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
